import React, { useState } from 'react'

import { Icon } from 'components/Icon'

export interface NotificationProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * It determines the placement of the bell
   */
  bellPlacement?: 'start' | 'end'
  /**
   * Number of notifications
   */
  value?: number
}

export const Notification = React.forwardRef<HTMLDivElement, NotificationProps>(
  (props, ref) => {
    const { children, bellPlacement = 'end', value } = props
    const [open, setOpen] = useState(false)
    return (
      <div className="max-w-md py-4 px-8 bg-white rounded-lg my-20" ref={ref}>
        <div
          className={`flex ${
            bellPlacement === 'end' ? 'md:justify-end' : 'md:justify-start'
          } -mt-16`}
        >
          <span
            className="relative inline-block cursor-pointer"
            onClick={() => setOpen(!open)}
            onKeyDown={() => setOpen(!open)}
            role="button"
            tabIndex={0}
          >
            <Icon
              className="text-full fill-current"
              icon="bell"
              iconSize="30px"
            />
            {value > 0 && (
              <span className="absolute top-0 right-0 items-center justify-center px-1 py-1 text-xs leading-none text-light-50 transform translate-x-1/3 bg-flamingo rounded-full h-4 w-4 flex">
                {value}
              </span>
            )}
          </span>
        </div>
        {open && children}
      </div>
    )
  }
)
